import { SceneAssets } from "@monsterverse/asset-constants";
import { IslandType } from "@monsterverse/island-types";

export function getIslandType(groupId: string): IslandType {
  if (groupId.startsWith("community-")) {
    return IslandType.Home;
  } else if (groupId.startsWith("playground-")) {
    return IslandType.Playground;
  } else if (groupId.startsWith("public-roleplay-")) {
    return IslandType.PublicRoleplay;
  }
  return IslandType.Class;
}

export function getDefaultIslandScene(groupId: string) {
  switch (getIslandType(groupId)) {
    case IslandType.Class:
      return SceneAssets.ClassIsland;
    case IslandType.Home:
      return SceneAssets.HomeIsland;
    case IslandType.Playground:
      return SceneAssets.PlaygroundIsland;
    case IslandType.PublicRoleplay:
      return SceneAssets.PublicRoleplayIsland;
  }
}

export function getServerRoomName(groupId: string) {
  switch (getIslandType(groupId)) {
    case IslandType.Class:
      return "class";
    case IslandType.Home:
      return "home";
    case IslandType.Playground:
      return "playground";
    case IslandType.PublicRoleplay:
      return "publicRoleplay";
  }
}
